import { useLocation } from "react-router-dom";

function ServicePage() {
  const { state } = useLocation();
  const { data } = state;
  void data; // data available for future use

  return (
    <div className="max-w-3xl px-4 mx-auto sm:px-8">
      <div className="py-8">
        <div className="inline-block overflow-hidden rounded-lg shadow">{/* <Results sample_results={sample_results} /> */}</div>
      </div>
    </div>
  );
}

export default ServicePage;
